<template>
  <div class="wlx-cer-signature-wrapper">
    <div class="wlx-cer-head">证书签名上传</div>
    <div class="wlx-cer-content clearfix">
        <div class="wlx-cer-left-title">填写考核站点负责人姓名并上传签名图片</div>
        <div class="wlx-cer-content-left fl">
            <div class="wlx-left-content">
                <div style="display:inline-block;">
                    <p>1. 用途：用于纸质版物流管理1+x证书上的“考核站点负责人签章”</p>
                    <div class="wlx-cer-img-box">
                        <img class="wlx-cer-img" :src="cerImg" alt="" @click="ImgVisible = true">
                        <span style="color: #333;">点击图片查看</span>
                    </div>
                </div>
                <div>
                    <p>2.要求:</p>
                    <div class="wlx-cer-left-two">
                        <p>（1）考核站点负责人用手写签名的高清扫描件</p>
                        <p>（2）图片格式，不小于200kb</p>
                        <p>（3）一经确认不得修改，如考核站点负责人变更的需联系管理办公室统一修改</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="wlx-cer-content-right fl">
            <div class="wlx-cer-right-box">
                <a href="https://file.clpp.org.cn/ykt/ori/62aoalgo67ralzns3hnyea/KBRcFQPPbzzk7W28.doc?response-content-disposition=attachment;filename=附件：物流管理1+X考核站点负责人电子签章采集表.doc">附件：物流管理1+X考核站点负责人电子签章采集表.doc</a>
            </div>
            <div class="wlx-cer-right-box">
                <div class="wlx-cer-right-laber">考核站点负责人姓名：</div>
                <div class="wlx-cer-right-input">
                    <el-input  v-model="value" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="wlx-cer-right-box">
                <div class="wlx-cer-right-laber">站点负责人签名图片：</div>
                <div class="wlx-cer-right-input">
                    <imageUpload :url="urlAliyunOSS" :files.sync="Logo" format="image"></imageUpload>
                    <div v-if="isLoad">
                    <el-button type="primary" @click="leadNameUpload()" v-if="isSave">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog
        :visible.sync="ImgVisible"
        width="50%"
        top="3%"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        style="">
        <div style="width:90%;margin:0 auto;">
            <img width="100%" class="wlx-cer-img" :src="cerImg" alt="" >
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ImgVisible = false">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      cerImg: require("assets/images/wlx-cer-img.png"),
      value: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      Logo: "",
      ImgVisible:false,
      isLoad:false,
      isSave:true
    };
  },
//   components: {},
  components: {
    imageUpload
  },
  props: {
    certificateId:{
      type:String,
      default:""
    }
  },
  created() {
    this.getLeadNameInfo();
  },
  methods: {
    getPreservation() {
        console.log(this.Logo);
    },
    getLeadNameInfo(){
        var that = this;
        this.$http.post("/api/XOrg/School/getLeadNameInfo",{
            certificateId:this.certificateId
        }).then(function(res) {
            if (res.code == 1) {
                that.value = res.LeadName;
                that.Logo = res.LeadNameUrl;
                that.isLoad = true;
                // if(res.LeadName == '' || res.LeadNameUrl==''){
                //     that.isSave = true;
                // }
            }
        });
    },
    leadNameUpload(){
        var that = this;
        this.$http.post("/api/XOrg/School/leadNameUpload",{
            leadName:this.value,
            leadNameUrl: this.Logo,
            certificateId:this.certificateId
        }).then(function(res) {
            if (res.code == 1) {
                that.$message.success(res.msg);
            }else{
                that.$message.warning(res.msg);
            }
        });
    }
  }
};
</script>
<style lang="scss">
.wlx-cer-signature-wrapper{
    padding: 0px 30px;
    .wlx-cer-head{
        line-height: 48px;
        font-size: 18px;
        border-bottom: 1px solid #ccc;
    }
    .wlx-cer-content{
        padding-top: 20px;
    }
    .wlx-cer-content-left{
        margin-top: 15px;
        width: 590px;
        border-right: 1px solid #CCCCCC;
    }
    .wlx-cer-left-title{
        color: #2D82FF;
        padding-left: 10px;
        border-left: 4px solid #2D82FF;
        font-size: 18px;
    }
    .wlx-left-content{
        color: #FF2D50;
        font-size: 14px;
        line-height: 26px;
    }
    .wlx-cer-img-box{
        width: 210px;
        margin: 20px auto;
        text-align: center;
    }
    .wlx-cer-img{
        height: auto;
        width: 100%;
    }
    .wlx-cer-left-two{
        padding-left: 15px;
    }
    .wlx-cer-content-right{
        margin-left: 40px;
    }
    .wlx-cer-right-box{
        margin: 15px 0px;
    }
    .wlx-cer-right-laber{
        display: inline-block;
        vertical-align: top;
    }
    .wlx-cer-right-input{
        display: inline-block;
        width: calc(100% - 140px);
    }
}
</style>
